import { defineStore } from 'pinia'
import { languageMap, defaultLang } from '@/plugins/languageMapping'
import { Language } from '@/enum/enum'

export type SupportedLanguage = Language.ZhTw | Language.JaJp

const SUPPORTED_LANGUAGES: SupportedLanguage[] = [Language.ZhTw, Language.JaJp]

export const userStore = defineStore('userStore', {
  state: () => ({
    accessToken: undefined as string | undefined,
    language: defaultLang as SupportedLanguage,
  }),
  getters: {},
  actions: {
    setAccessToken(token: string) {
      this.accessToken = token
    },
    clearAccessToken() {
      this.accessToken = undefined
    },
    setLanguage(lang: string) {
      const normalized = languageMap[lang] as SupportedLanguage | undefined
      this.language = (normalized && SUPPORTED_LANGUAGES.includes(normalized))
        ? normalized
        : (defaultLang as SupportedLanguage)
    },
  },

  /** 是否儲存起來 */
  persist: {
    // 目前使用 sessionStorage（關閉分頁後清除）
    // 若需跨 session 保留語系，可改為：
    //   storage: localStorage
    // 或僅對 language 欄位使用 localStorage：
    //   paths: ['language'],
    //   storage: localStorage,
    storage: sessionStorage,
  },
})
